<template>
    <div>
        <div style="position: absolute; align-items: center; justify-content: center; display: flex; width: 100%; height: auto; top: 0;">
          <!-- Fiber Optic Text -->
           <svg class="svg-container" viewBox="0 0 800 200">
            <text x="50%" y="50%" text-anchor="middle" font-size="80" font-family="Arial, sans-serif" class="text-outline">
              MY SOFT CODE
            </text>
          </svg>
        </div>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

 /* SVG Container */
 .svg-container {
            width: 80%;
            max-width: 1000px;
        }

        /* Glowing Stroke Effect */
        .text-outline {
            fill: none;
            stroke: cyan;
            stroke-width: 2;
            stroke-linecap: round;
            stroke-dasharray: 500;
            stroke-dashoffset: 500;
            animation: waveFlow 6s infinite linear, glowEffect 4s infinite alternate;
            cursor:default;
        }

        /* Glowing Animation */
        @keyframes glowEffect {
            from { stroke-opacity: 0.5; filter: drop-shadow(0 0 10px cyan); }
            to { stroke-opacity: 1; filter: drop-shadow(0 0 20px cyan); }
        }

        /* Fiber Optic Wave Animation */
        @keyframes waveFlow {
            from { stroke-dashoffset: 500; }
            to { stroke-dashoffset: 0; }
        }


</style>